/**
 * Alcance de lectura de Packs por rol.
 *
 * El backend restringe `status=ALL|INACTIVE|EXPIRED|SOLD_OUT` y `validAt` a los
 * roles de plataforma; `ALIADO_ADMIN` y `CONTADOR` solo pueden consultar `ACTIVE`
 * y dentro de vigencia. La UI refleja esa restricción para no ofrecer un 403.
 */
import type { AdminRole } from '@goelectric/shared-types';

/** Roles que pueden filtrar y ver todos los estados del catálogo de packs. */
export const PACKS_ALL_STATUS_ROLES: readonly AdminRole[] = [
  'SUPER_ADMIN',
  'SOPORTE_N3',
  'MARKETING',
];

/** `true` si el rol puede consultar estados distintos de `ACTIVE`. */
export function canFilterPackStatus(role: AdminRole | undefined): boolean {
  return role !== undefined && PACKS_ALL_STATUS_ROLES.includes(role);
}
